import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
    ProductIcon, AdvertisementIcon, FAQIcon, Company, SeminarIcon, LiveStreamIcon, SettingSellProduct,
} from '../../components/Icons/Icon';

const organizerRoutes = [
    {
        path: '/product-management',
        param: ':shortName',
        name: <FormattedMessage id="organizerRoutes.productList" />,
        icon: ProductIcon,
        customName: 'exhibit_work',
        text_type: 2,
    },
    {
        path: '/setting-sell-product',
        param: ':shortName',
        name: <FormattedMessage id="organizerRoutes.settingSellProduct" />,
        icon: SettingSellProduct,
        customName: 'product_sales_settings',
        text_type: 2,
    },
    {
        path: '/seminar-management',
        param: ':shortName',
        name: <FormattedMessage id="organizerRoutes.seminarList" />,
        icon: SeminarIcon,
        customName: 'seminar_registration_work',
        text_type: 1,
    },
    {
        path: '/livestream-management',
        param: ':shortName',
        name: <FormattedMessage id="organizerRoutes.liveStream" />,
        icon: LiveStreamIcon,
        customName: 'livestreaming_info_management',
        text_type: 0,
    },
    {
        path: '/advertisement-register',
        param: ':shortName',
        name: <FormattedMessage id="organizerRoutes.adsRegister" />,
        icon: AdvertisementIcon,
        customName: 'advertising_registration',
    },
    {
        path: '/company-info',
        param: ':shortName',
        name: <FormattedMessage id="organizerRoutes.companyInfo" />,
        icon: Company,
        customName: 'confirmation_company_info',
        text_type: 4,
    },
    {
        path: '/faq',
        param: ':shortName',
        name: <FormattedMessage id="organizerRoutes.faq" />,
        icon: FAQIcon,
        customName: 'faq',
    },
];

export default organizerRoutes;
